import { render, staticRenderFns } from "./cubes-icon.vue?vue&type=template&id=172a7d5c&scoped=true"
import script from "./cubes-icon.vue?vue&type=script&lang=js"
export * from "./cubes-icon.vue?vue&type=script&lang=js"
import style0 from "./cubes-icon.vue?vue&type=style&index=0&id=172a7d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a7d5c",
  null
  
)

export default component.exports